import { store } from "./Redux/store";
import axios from "axios";
import React from 'react';
import { createRoot } from 'react-dom/client';
import Sessionexpired from "./components/SessionExpired";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
    // "Access-Control-Allow-Origin": "*",
    // 'api-key': 'b63bd82b-4a83-4d28-909d-30ce29614589',
    // 'lang': lang==='ar'?'ar_001':'en_US'
  },
});

// axiosInstance.interceptors.request.use(function (config) {
//   const { login } = store.getState();
//   const auth = "";

//   config.headers["access-token"] = login?.user?.result?.access_token;
//   // config.headers["lang"] =  "ar_001";

//   return config;
// });

axiosInstance.interceptors.request.use(function (config) {
  const { login } = store.getState();
  const token = login?.user?.result?.access_token;
  const selectedStore = login?.selectedStore;
  const masterStore = login?.masterStore;
  const store_id = login?.user?.result?.company_id

  console.log("LODFDFEF", store_id);



  // Attach token
  if (token) {
    config.headers["access-token"] = token;
  }

  // Attach store info with kebab-case header names
  // if (selectedStore) {
  config.headers["Store-Id"] = selectedStore?.store_id || store_id;
  config.headers["Is-All-Store"] = selectedStore?.is_select_all_store
    ? "True"
    : "false";


  if (masterStore) {
    config.headers["Master-Store-Id"] = masterStore?.store_id;
  }

  // }



  return config;
});

const showModal = () => {
  const modalContainer = document.createElement('div');
  document.body.appendChild(modalContainer);

  const root = createRoot(modalContainer);
  root.render(<Sessionexpired />);
};

axiosInstance.interceptors.response.use(
  (response) => {
    const errorMessage = response?.data?.result?.message;
    const errorResult = response?.data?.result;
    if (typeof errorResult === 'string' && errorResult.includes('401 UNAUTHORIZED') || errorMessage === "Invalid Token") {
      showModal();
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    if (error?.response?.data?.result?.message === "token not valid") {
      showModal();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
